import { render } from "./RedpackInfo.vue?vue&type=template&id=59160414&scoped=true&ts=true"
import script from "./RedpackInfo.vue?vue&type=script&lang=ts"
export * from "./RedpackInfo.vue?vue&type=script&lang=ts"

import "./RedpackInfo.vue?vue&type=style&index=0&id=59160414&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59160414"]])

export default __exports__